// src/utils/i18n.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import en from './locales/en.json';
import id from './locales/id.json';
import zh from './locales/zh.json';

export const translations = { en, id, zh };

const LanguageContext = createContext(undefined);

const safeGet = (obj, path) => {
  if (obj == null) return undefined;
  if (Object.prototype.hasOwnProperty.call(obj, path)) return obj[path];
  const parts = String(path).split('.');
  let cur = obj;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
};

export const LanguageProvider = ({ children, defaultLang = 'en' }) => {
  const [language, setLanguage] = useState(defaultLang);

  useEffect(() => {
    try {
      const saved = localStorage.getItem('language');
      if (saved && translations[saved]) setLanguage(saved);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const changeLanguage = (lang) => {
    if (!translations[lang]) return;
    try {
      localStorage.setItem('language', lang);
    } catch (e) {
      console.log(e);
    }
    setLanguage(lang);
  };

  const t = (key, fallback = '') => {
    if (!key) return fallback;
    const dict = translations[language] ?? {};
    const val = safeGet(dict, key);
    return val ?? fallback;
  };

  const format = (template = '', params = {}) => String(template).replace(/\{([^}]+)\}/g, (_, k) => params[k] ?? '');
  return React.createElement(LanguageContext.Provider, { value: { language, changeLanguage, t, format, translations } }, children);
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
